<template>
	<div
		class="carousel_arrow"
		:class="[{'next': direction === 'next', 'prev': direction === 'prev'}, theme]"
	>
		<chevron-right></chevron-right>

	</div>
</template>

<script>
import Arrow from '../../images/arrow-basic.svg';
import ChevronRight from './ChevronRight.vue';

export default {
	data() {
		return {
			arrow: Arrow,
		};
	},

	props: {
		direction: {
			default: 'next',
		},
		theme: {
			default: 'light',
		},
	},

	computed: {},

	watch: {},

	methods: {},

	components: { ChevronRight },

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.carousel_arrow {
	width: 48px;
	height: 48px;
	border-radius: 50%;
	background: var(--cobalt) 0% 0% no-repeat padding-box;
	border: 1px solid transparent;
	transition: 0.2s ease all;
	display: flex;
	justify-content: center;
	align-items: center;
	opacity: 1;

	&.swiper-button-disabled {
		opacity: 0.5 !important;
		transition: 0.2s ease all;
	}

	svg {
		height: 24px;
		transition: 0.2s ease all;

		&::v-deep {
			path {
				fill: var(--white);
				transition: 0.2s ease all;
			}
		}
	}

	&.next {
		margin-right: 0;
		right: -24px;

		svg {
			margin-right: 0;
		}
	}

	&.prev {
		transform: rotate(180deg);
		margin-left: 0;
		left: -24px;

		svg {
			margin-left: 0;
		}
	}

	&:hover {
		transition: 0.2s ease all;
		background: var(--white);
		border: 1px solid var(--cobalt);

		svg {
			height: 16px;
			transition: 0.2s ease all;

			&::v-deep {
				path {
					fill: var(--cobalt);
					transition: 0.2s ease all;
				}
			}
		}
	}
}
</style>